import React from "react";

// reactstrap components
import {
  Form,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  InputGroupAddon,
  InputGroup,
  Container,
} from "reactstrap";

import {
  PanelHeader, 
  Button,
  // CardCategory
} from "components";

import Select from "react-select";
import PhoneInput from 'react-phone-number-input'


function BusinessLaunchForm(props) {
    const { name2, name2State, 
            email2, email2State, 
            trait2State, selectedTraitValue2, businessTraitOptions, 
            addressState, address, 
            phoneState, phone, 
            businessUrlState, businessUrl,
            contactNameState, contactName,
            contactPhoneState, contactPhone, 

             } = props 

    const { submitted2, isBot, botChecked, talentMode } = props 

    const { checkName2, checkEmail2, selectTrait2, 
            checkAddress,  checkPhoneNumber, checkBusinessWebsiteUrl,checkContactName, checkContactPhoneNumber,
            handleLaunchSubmit } = props 

  return (
    <>
     <Row className='mt-4'>
        <Col lg="12">
            <Label className="form-control-label">Business Name
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="name2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="name2" 
                delay={0}> 
                Enter your business's name 
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + name2State}
            >
                <Input
                type="text" 
                name="name2" 
                value={name2}
                placeholder="Your business's name"
                onBlur={e => checkName2(e )}
                onChange={e => checkName2(e)}
                valid={
                    name2State === "has-success"
                }
                invalid={
                    name2State === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12" >
            <Label className="form-control-label">Business Email
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="email2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="email2" 
                delay={0}> 
                Enter your business's email address.  
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + email2State}
            >
                <Input
                type="email" 
                name="email2" 
                value={email2}
                placeholder="Your business's email"
                onBlur={e => checkEmail2(e)}
                onChange={e => checkEmail2(e)}
                valid={
                    email2State === "has-success"
                }
                invalid={
                    email2State === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12" >
            <Label className="form-control-label">Business Type
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="selectedTrait2"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="selectedTrait2" 
                delay={0}> 
                Choose the business type that best describes your business. 
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + trait2State}
            >
                <Select
                className="react-select primary wrap-cursor-pointer"
                classNamePrefix="react-select"
                placeholder="Choose Business Type"
                name="selectedTrait2"
                value={selectedTraitValue2}
                options={businessTraitOptions}
                onChange={value => selectTrait2(value) }
                />
            </FormGroup>
            </Col>
            <Col lg="12">
            <Label className="form-control-label">Business Address
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="address"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="address" 
                delay={0}> 
                Enter your business's address
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + addressState}
            >
                <Input
                type="text" 
                name="address" 
                value={address}
                placeholder="Your business's address"
                onBlur={e => checkAddress(e)}
                onChange={e => checkAddress(e)}
                valid={
                    addressState === "has-success"
                }
                invalid={
                    addressState === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12" >
            <Label className="form-control-label">Business Phone Number
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="phone"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="phone" 
                delay={0}> 
                Enter your business's phone number  
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + phoneState}
            >
                <div className='phone-input '>
                <PhoneInput
                    placeholder="Your business's phone number"
                    value={phone}
                    defaultCountry="US"
                    onChange={e => checkPhoneNumber(e)}/>
                </div>
            </FormGroup>
            </Col>

            <Col lg="12" >

            <Label className="form-control-label ">Business Website
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="businessUrl"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="businessUrl" 
                delay={0}> 
                Enter your business's website.  
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + businessUrlState}
            >
                <Input
                type="url" 
                name="businessUrl" 
                className='bg-transparent surtitle-light-gray'
                value={businessUrl}
                placeholder="Your business's website"
                onBlur={e => checkBusinessWebsiteUrl(e)}
                onChange={e => checkBusinessWebsiteUrl(e)}  
                valid={
                    businessUrlState === "has-success"
                }
                invalid={
                    businessUrlState === "has-danger"
                }
                />
            </FormGroup>
            </Col>
            <Col lg="12">
            <Label className="form-control-label">Contact's Name
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="contactName"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="contactName" 
                delay={0}> 
                Enter the name of your business's contact. 
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + contactNameState}
            >
                <Input
                type="text" 
                name="contactName" 
                value={contactName}
                placeholder="Your contact's name"
                onBlur={e => checkContactName(e )}
                onChange={e => checkContactName(e)}
                valid={
                    contactNameState === "has-success"
                }
                invalid={
                    contactNameState === "has-danger"
                }
                />
            </FormGroup>
            </Col>

            <Col lg="12" >
            <Label className="form-control-label">Contact's Mobile Number
            <i className="pl-2 fas fa-info-circle surtitle-gray cursor-pointer " 
                    id="contactPhone"
                />
                <UncontrolledTooltip  
                placement="right" 
                target="contactPhone" 
                delay={0}> 
                Enter your contact's mobile number  
                </UncontrolledTooltip>

            </Label>
            <FormGroup 
            className={"mt-2 " + contactPhoneState}
            >
                <div className='phone-input '>
                <PhoneInput
                    placeholder="Your conact's mobile number"
                    value={contactPhone}
                    defaultCountry="US"
                    onChange={e => checkContactPhoneNumber(e)}/>
                </div>
            </FormGroup>
            </Col>
            <Col xs={12} className="text-center">
            <Button style={{fontSize:"1rem"}} disabled={submitted2 || isBot || !botChecked} color={talentMode ? "primary" : "purple"}s ize="lg" block className={talentMode ? " title bg-gradient-livenyte" : " title bg-gradient-purple"}onClick={e => handleLaunchSubmit(e)}>
                {submitted2 ? 'Launch request sent' : 'Join'}
            </Button>
            </Col>
        </Row>
    </>
  );
}

export default BusinessLaunchForm;
